import { InterviewTable } from "../interfaces/Interview";

export interface IInterviewCalendarEvent {
	id: number;
	title: string;
	start: Date;
	end: Date;
	allDay: boolean;
}

export function getCalendarEventsForInterviews(
	data: InterviewTable[]
): IInterviewCalendarEvent[] {
	return data.map((interview) => {
		const date = new Date(interview.datetime*1000);
		return {
			id: interview.id,
			title: `${interview.vacancy.name} - ${interview.candidate.full_name}`,
			allDay: true,
			start: date,
			end: date,
		};
	});
}
